import React from 'react';

const CompanyNameItem = ({item}) => (
  <div>
    {item.name}<br/>
    <small>{item.websiteUrl} &nbsp; {item.province}</small>
  </div>
);

export default CompanyNameItem;